import * as React from "react";

function SvgCustify(props, ref) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...{ ...props, ref }}
    >
      <g clipPath="url(#Custify_svg__clip0)">
        <path fill="#fff" d="M0 0h236v60H0z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M51.28 51.144a25.233 25.233 0 01-9.146-10.41c2.533-2.861 4.082-6.612 4.082-10.733s-1.55-7.871-4.082-10.732A25.237 25.237 0 0151.28 8.857C56.668 14.281 60 21.752 60 30.001c0 8.249-3.332 15.72-8.72 21.143zm-21.296-10.58c-5.83 0-10.555-4.73-10.555-10.563 0-5.834 4.725-10.562 10.555-10.562 5.828 0 10.555 4.728 10.555 10.562 0 5.833-4.727 10.563-10.555 10.563z"
          fill="#006CBB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M36.858 15.321a16.128 16.128 0 00-6.859-1.537c-8.956 0-16.215 7.26-16.215 16.217 0 8.956 7.26 16.216 16.215 16.216 2.455 0 4.774-.561 6.859-1.537a31.777 31.777 0 009.136 10.697A29.856 29.856 0 0130 60.001C13.431 60.001 0 46.57 0 30.001 0 13.43 13.431 0 30 0a29.839 29.839 0 0115.994 4.625 31.763 31.763 0 00-9.136 10.696z"
          fill="#2A2B3C"
        />
      </g>
      <defs>
        <clipPath id="Custify_svg__clip0">
          <path fill="#fff" d="M0 0h236v60H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default React.forwardRef(SvgCustify);
